module.exports = ".cursor-pointer {\n  cursor: pointer !important; }\n"